import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as CreDtos from "../CRE.dtos";

export const contactUsSettingsApi = {
    get: () => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.GetContactUs();
        const request = client.get(query);
        return Observable.from(request);
    },
    upsert: (contactUsSettings: CreDtos.ContactUsSettings) => {
        var client = new JsonServiceClient("");
        var query = new CreDtos.PostContactUs();
        query.contactUsSettings = contactUsSettings;
        const request = client.post(query);
        return Observable.from(request);
    }
};




// WEBPACK FOOTER //
// ./src/services/contactUsSettings.service.ts